import type { ReactNode } from 'react'

/**
 * Kerangka satu bagian halaman.
 *
 * Semua bagian memakai garis rambut yang sama sebagai pemisah, sehingga seluruh
 * halaman terbaca sebagai satu lembar berbaris — bahasa yang sama dengan papan
 * minggu di atasnya, bukan tumpukan kartu.
 */
export function Bagian({
  id,
  judul,
  keterangan,
  children,
}: {
  id?: string
  judul: string
  keterangan?: ReactNode
  children: ReactNode
}) {
  return (
    <section id={id} className="scroll-mt-16 border-b border-border">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20">
        <header className="max-w-2xl">
          <h2 className="text-balance text-2xl font-semibold tracking-tight sm:text-3xl">
            {judul}
          </h2>
          {keterangan && (
            <div className="mt-3 text-pretty text-muted-foreground">{keterangan}</div>
          )}
        </header>

        <div className="mt-10">{children}</div>
      </div>
    </section>
  )
}

/** Keadaan gagal yang sama bentuknya di seluruh halaman. */
export function GagalMuat({ pesan, ulangi }: { pesan: string; ulangi: () => void }) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 border-t border-border pt-6 text-sm">
      <span className="text-muted-foreground">{pesan}</span>
      <button
        type="button"
        onClick={ulangi}
        className="rounded-sm text-foreground underline underline-offset-4 decoration-border hover:decoration-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      >
        Try again
      </button>
    </div>
  )
}
